/**
 * Wask — star ratings on product cards
 * Theme asset: assets/wask-card-rating.js
 *
 * Loaded once per page from theme.liquid. It must live here rather than inside
 * the card snippet, because sections that load after the page - "You may also
 * like", collection filters, infinite scroll - are injected as HTML, and
 * browsers do not execute <script> tags that arrive that way. A script in the
 * layout runs normally and can watch for cards appearing later.
 *
 * Expects these on the page (set in theme.liquid):
 *   window.WASK_REVIEWS_JSON
 *   window.WASK_REVIEWS_BACKUP
 */
(function () {
  if (window.__waskCardRatingInit) { return; }
  window.__waskCardRatingInit = true;

  var JSON_URL   = window.WASK_REVIEWS_JSON   || 'https://dorotapankowska.com/etsy-widgets/wask/wask-reviews.json';
  var BACKUP_URL = window.WASK_REVIEWS_BACKUP || '';

  var STAR = '<svg viewBox="0 0 24 24"><path d="M12 2l2.9 6.6 7.1.7-5.4 4.8 1.6 7L12 17.4 5.8 21l1.6-7L2 9.3l7.1-.7z"/></svg>';
  var FIVE = STAR + STAR + STAR + STAR + STAR;

  /* ---------- styles, injected once ---------- */
  if (!document.getElementById('wask-cardrating-styles')) {
    var css = document.createElement('style');
    css.id = 'wask-cardrating-styles';
    css.textContent =
      '.wask-cardrating{display:block;line-height:0;margin:.4rem 0 0;' +
        '--wcr-size:1.2rem;--wcr-accent:#5f6859}' +
      '.wask-cardrating--reserved{min-height:calc(var(--wcr-size) * 1.35)}' +
      '.wask-cardrating__stars{position:relative;display:none;height:var(--wcr-size);opacity:0;transition:opacity .25s ease}' +
      '.wask-cardrating.is-ready .wask-cardrating__stars{display:inline-block}' +
      '.wask-cardrating.is-visible .wask-cardrating__stars{opacity:1}' +
      '.wask-cardrating__row{display:flex;gap:1.5px;white-space:nowrap}' +
      '.wask-cardrating__row svg{width:var(--wcr-size);height:var(--wcr-size);flex:0 0 auto;' +
        'fill:rgba(var(--color-foreground,18 18 18),.18)}' +
      '.wask-cardrating__clip{position:absolute;top:0;left:0;overflow:hidden;height:var(--wcr-size)}' +
      '.wask-cardrating__clip .wask-cardrating__row svg{fill:var(--wcr-accent)}' +
      '@media (prefers-reduced-motion:reduce){.wask-cardrating__stars{transition:none}}';
    document.head.appendChild(css);
  }


  /**
   * Fetch with a hard time limit.
   *
   * Without this, a server that is down but still accepting connections
   * leaves the browser waiting for its own network timeout - often 10 to 30
   * seconds - before we can fall back to the theme's backup copy.
   */
  function fetchLimited(url, ms) {
    if (!window.AbortController) { return fetch(url); }
    var ctrl = new AbortController();
    var timer = setTimeout(function () { ctrl.abort(); }, ms || 3000);
    return fetch(url, { signal: ctrl.signal }).then(function (r) {
      clearTimeout(timer);
      return r;
    }, function (e) {
      clearTimeout(timer);
      throw e;
    });
  }

  /* Remember a recent failure so other pages in this visit skip the wait. */
  var FAIL_KEY = 'waskReviewsDown';
  function recentlyDown() {
    try {
      var t = parseInt(sessionStorage.getItem(FAIL_KEY), 10);
      return t && (Date.now() - t) < 600000;   // 10 minutes
    } catch (e) { return false; }
  }
  function markDown() {
    try { sessionStorage.setItem(FAIL_KEY, String(Date.now())); } catch (e) {}
  }

  /* ---------- one fetch, shared with the bar and the full section ---------- */
  function loadReviews() {
    if (window.__waskReviewsPromise) { return window.__waskReviewsPromise; }

    var primary = recentlyDown()
      ? Promise.reject(new Error('skipped, recently down'))
      : fetchLimited(JSON_URL, 3000).then(function (r) {
          if (!r.ok) { throw new Error('bad response'); }
          return r.json();
        });

    window.__waskReviewsPromise = primary.catch(function () {
      markDown();
      if (!BACKUP_URL) { throw new Error('no backup'); }
      return fetchLimited(BACKUP_URL, 8000).then(function (r) {
        if (!r.ok) { throw new Error('no backup'); }
        return r.json();
      });
    });

    return window.__waskReviewsPromise;
  }


  /**
   * Draw the stars. The row has to be measured to know how much to fill, and a
   * card that is still being laid out can measure zero, so keep retrying
   * rather than leaving an empty gap behind.
   */
  function paint(el, avg, attempt) {
    attempt = attempt || 0;

    var rows = el.querySelectorAll('.wask-cardrating__row');
    if (rows.length < 2) { return; }

    if (!rows[0].innerHTML) {
      rows[0].innerHTML = FIVE;
      rows[1].innerHTML = FIVE;
    }

    el.classList.add('is-ready');

    var width = rows[0].getBoundingClientRect().width;

    if (!width) {
      if (attempt < 30) {
        requestAnimationFrame(function () { paint(el, avg, attempt + 1); });
      } else if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (entries, obs) {
          if (entries[0].isIntersecting) { obs.disconnect(); paint(el, avg, 0); }
        });
        io.observe(el);
      }
      return;
    }

    rows[1].style.width = width + 'px';
    el.querySelector('.wask-cardrating__clip').style.width = (avg / 5 * width) + 'px';

    var sr = el.querySelector('.wask-cardrating__sr');
    if (sr) { sr.textContent = avg.toFixed(1) + ' out of 5 stars'; }

    requestAnimationFrame(function () { el.classList.add('is-visible'); });
  }

  function apply(data) {
    var cards = document.querySelectorAll('.wask-cardrating:not([data-wcr-done])');

    Array.prototype.forEach.call(cards, function (el) {
      el.setAttribute('data-wcr-done', '1');

      var handle    = el.getAttribute('data-handle');
      var shopAvg   = parseFloat(el.getAttribute('data-shop-avg')) || 0;
      var shopCount = parseInt(el.getAttribute('data-shop-count'), 10) || 0;

      var prod = (data && data.products) ? data.products[handle] : null;
      var etsy = (prod && prod.etsy_rating) ? prod.etsy_rating : null;

      var shopSum = shopAvg * shopCount;

      /* Shopify's Shop total still includes anything excluded on policy
         grounds, so take it back out before combining. */
      var adj = (prod && prod.shop_adjust) ? prod.shop_adjust : null;
      if (adj && adj.count > 0 && shopCount > 0) {
        shopSum   = Math.max(0, shopSum - adj.sum);
        shopCount = Math.max(0, shopCount - adj.count);
      }

      var sum = 0, count = 0;
      if (shopCount > 0)          { sum += shopSum;                   count += shopCount; }
      if (etsy && etsy.count > 0) { sum += etsy.average * etsy.count; count += etsy.count; }

      if (count > 0) {
        var avg = sum / count;
        el.setAttribute('data-wcr-avg', avg);
        paint(el, avg, 0);
      } else {
        el.classList.remove('wask-cardrating--reserved');
      }
    });
  }

  function run() {
    loadReviews().then(apply).catch(function () { apply(null); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Cards that appear later: recommendations, filters, infinite scroll.
     No refetch - the promise is reused. */
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () {
        if (document.querySelector('.wask-cardrating:not([data-wcr-done])')) { run(); }
      }, 120);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Redraw on resize: the star row changes width, so the fill must too. */
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var painted = document.querySelectorAll('.wask-cardrating.is-visible[data-wcr-avg]');
      Array.prototype.forEach.call(painted, function (el) {
        paint(el, parseFloat(el.getAttribute('data-wcr-avg')) || 0, 0);
      });
    }, 200);
  });
})();
